module.exports = new __parcel__URL__("default-project-avatar.6f6d91f9.svg").toString();